import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import useResizeObserver from 'use-resize-observer'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { useResizer } from '../contexts/Resizer'
import styled from '@emotion/styled'

import Listas from '@/components/Feature/Candidatos/Blocks/Listas'
import Hero from '@/components/Feature/Candidatos/Hero'

let animations = {
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
}

const Main = styled(motion.div)``

const IndexPage = () => {
  const { ref, width, height } = useResizeObserver()
  const setArea = useResizer()

  useEffect(() => {
    if (setArea) {
      let timeout = setTimeout(() => {
        setArea(area => {
          if (area.width !== width || area.height !== height) {
            return { width, height }
          } else {
            return area
          }
        })
      }, 150)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [width, height, setArea])

  const heroContent = {
    title: '¿Quiénes son los candidatos y candidatas?',
    description:
      'El 21 de noviembre las chilenas y chilenos escogieron a los candidatos y candidatas que conformarán a los diputados, senadores, y presidentes de Chile. La Tercera recopiló toda la información disponible, poniéndola a disposición de sus lectores.',
  }

  const winnerContent = {
    title: 'Candidatos Electos',
    description: '',
    list: [
      {
        title: 'Electos',
        link: '/electos/',
        description: '',
      },
    ],
  }

  const listContent = {
    title: 'Listas completas',
    description: '',
    list: [
      {
        title: 'Candidatos a Presidente',
        link: '/presidentes/',
        description: '',
      },
      {
        title: 'Candidatos a Senador',
        link: '/senadores/',
        description: '',
      },
      {
        title: 'Candidatos a Diputado',
        link: '/diputados/',
        description: '',
      },
      {
        title: 'Consejeros Regionales',
        link: 'https://presidenciales2021.servel.cl/candidaturas-consejeras-y-consejeros-regionales/',
        description:
          'No tenemos un listado detallado de los consejeros regionales. Puedes ver a los consejeros regionales en el sitio del servel.',
      },
      {
        title: 'Por lista',
        link: '/listas/',
        description: 'Candidatos por listas',
      },
      {
        title: 'Por partido político',
        link: '/partidos-politicos/',
        description: 'Candidatos por partido político',
      },
    ],
  }

  return (
    <Main
      ref={ref}
      initial="exit"
      animate="enter"
      exit="exit"
      variants={animations}>
      <Layout>
        <SEO />
        <Hero title={heroContent.title} description={heroContent.description} />
        <Listas
          title={winnerContent.title}
          description={winnerContent.description}
          list={winnerContent.list}
        />
        <Listas
          title={listContent.title}
          description={listContent.description}
          list={listContent.list}
        />
      </Layout>
    </Main>
  )
}

export default IndexPage
